module.exports = __webpack_public_path__ + "assets/img/shop_btn.40ded9fe.png";